<script>
import TimePicker from '@/components/common/pickers/TimePicker.vue'
export default {
  components: {
    TimePicker
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  }
}
</script>
<template>
  <v-row>
    <v-col>
      <TimePicker
        id="dailyTime"
        v-model="value.time"
        :disabled="disabled"
        @input="$emit('input', value)"
      />
    </v-col>
  </v-row>
</template>
